import React from "react"
import {RefTable, DefaultProps} from "../RefTable"

export const Courier = (props)=><RefTable {...props}/>;

Courier.defaultProps = {
    ...DefaultProps,
    title: "Couriers",
    tableSchema: "ref_couriers",
    tableName: "courier",
    edit: true,
}
